export default function(ref) {
  return {
    methods: {
      focus() {
        this.$refs[ref].focus();
      }
    }
  };
};



// WEBPACK FOOTER //
// ./node_modules/element-ui/src/mixins/focus.js